import React from 'react';
import styles from './creditSkeletons.module.css';

const Bar = ({ className }) => <span className={`${styles.bar} ${className}`} />;

// role=status + aria-label: ÑÐºÑÐ¸Ð½ÑÐ¸Ð´ÐµÑ Ð¾Ð±ÑÑÐ²Ð¸Ñ Ð·Ð°Ð³ÑÑÐ·ÐºÑ, Ð° Ð½Ðµ Ð¿ÑÐ¾ÑÑÑÑ Ð½Ð°Ð±Ð¾Ñ Ð¿ÑÑÑÑÑ Ð¿Ð¾Ð»Ð¾Ñ
const Skeleton = ({ label, children, ...props }) => (
  <div role="status" aria-busy="true" aria-label={label} {...props}>
    {children}
  </div>
);

/** ÐÐ¼ÐµÑÑÐ¾ Ð±Ð»Ð¾ÐºÐ° Â«ÐÐ°Ð½Ð½ÑÐµ Ð·Ð°ÑÐ²ÐºÐ¸Â»: ÑÐµ Ð¶Ðµ Ð²Ð¾ÑÐµÐ¼Ñ Ð¿Ð¾Ð»ÐµÐ¹ Â«Ð¿Ð¾Ð´Ð¿Ð¸ÑÑ + Ð·Ð½Ð°ÑÐµÐ½Ð¸ÐµÂ». */
export const ApplicationSkeleton = () => (
  <Skeleton label="ÐÐ°Ð³ÑÑÐ¶Ð°ÐµÐ¼ Ð´Ð°Ð½Ð½ÑÐµ Ð·Ð°ÑÐ²ÐºÐ¸" className={styles.fields}>
    {Array.from({ length: 8 }, (_, i) => (
      <div key={i}>
        <Bar className={styles.label} />
        <Bar className={styles.value} />
      </div>
    ))}
  </Skeleton>
);

/** ÐÐ¼ÐµÑÑÐ¾ Ð±Ð»Ð¾ÐºÐ° Â«ÐÐ°Ð½ÐºÐ¸Â»: ÐºÐ°ÑÑÐ¾ÑÐºÐ° Ð±Ð°Ð½ÐºÐ° â Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿, Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ, ÑÑÐ°ÑÑÑ, Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÐµÐ»Ð¸, ÐºÐ½Ð¾Ð¿ÐºÐ°. */
export const BankOffersSkeleton = () => (
  <Skeleton label="ÐÐ°Ð³ÑÑÐ¶Ð°ÐµÐ¼ Ð¾ÑÐ²ÐµÑÑ Ð±Ð°Ð½ÐºÐ¾Ð²" className={styles.bank}>
    <div className={styles.bankHeader}>
      <Bar className={styles.logo} />
      <Bar className={styles.name} />
      <Bar className={styles.status} />
    </div>
    <div className={styles.bankInfo}>
      {Array.from({ length: 4 }, (_, i) => (
        <div key={i}>
          <Bar className={styles.label} />
          <Bar className={styles.value} />
        </div>
      ))}
    </div>
    <Bar className={styles.button} />
  </Skeleton>
);
